//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { deleteBatchApi } from '../api';
export default {
  name: 'DeleteCoupon',
  data: function data() {
    return {
      isShow: false
    };
  },
  methods: {
    open: function open(row) {
      this.params = row;
      this.isShow = true;
    },
    close: function close() {
      this.params = null;
      this.isShow = false;
    },
    submit: function submit() {
      var _this = this;
      deleteBatchApi([this.params.id]).then(function () {
        _this.$message.success('删除成功');
        _this.$emit('refresh');
        _this.close();
      }).catch(function () {
        _this.close();
      });
    }
  }
};